import { useEffect, useState } from 'react';

interface Sparkle {
  id: string;
  top: number;
  left: number;
  size: number;
  color: string;
  delay: number;
}

export default function GlobalSparkles() {
  const [sparkles, setSparkles] = useState<Sparkle[]>([]);

  useEffect(() => {
    const colors = ['emerald', 'teal', 'cyan', 'white', 'amber', 'rose'];
    
    const createSparkle = () => {
      const newSparkle: Sparkle = {
        id: `sparkle-${Date.now()}-${Math.random()}`,
        top: Math.random() * 100,
        left: Math.random() * 100,
        size: Math.random() * 20 + 15, // 15-35px (smaller)
        color: colors[Math.floor(Math.random() * colors.length)],
        delay: 0,
      };

      setSparkles(prev => [...prev, newSparkle]);

      // Remove sparkle after animation completes (4s)
      setTimeout(() => {
        setSparkles(prev => prev.filter(s => s.id !== newSparkle.id));
      }, 4000);
    };

    // Create sparkles at much longer intervals (every 8-15 seconds)
    const scheduleNextSparkle = () => {
      const delay = Math.random() * 7000 + 8000; // 8000-15000ms (8-15 seconds)
      setTimeout(() => {
        createSparkle();
        scheduleNextSparkle();
      }, delay);
    };

    scheduleNextSparkle();

    // Cleanup
    return () => {
      setSparkles([]);
    };
  }, []);

  const getColorFilter = (color: string) => {
    switch (color) {
      case 'emerald':
        return 'brightness(0) saturate(100%) invert(64%) sepia(98%) saturate(459%) hue-rotate(101deg) brightness(91%) contrast(86%)';
      case 'teal':
        return 'brightness(0) saturate(100%) invert(60%) sepia(51%) saturate(1345%) hue-rotate(133deg) brightness(91%) contrast(86%)';
      case 'cyan':
        return 'brightness(0) saturate(100%) invert(79%) sepia(26%) saturate(1234%) hue-rotate(142deg) brightness(94%) contrast(86%)';
      case 'amber':
        return 'brightness(0) saturate(100%) invert(77%) sepia(61%) saturate(1234%) hue-rotate(359deg) brightness(102%) contrast(101%)';
      case 'rose':
        return 'brightness(0) saturate(100%) invert(58%) sepia(89%) saturate(2341%) hue-rotate(316deg) brightness(99%) contrast(92%)';
      case 'white':
      default:
        return 'brightness(0) saturate(100%) invert(100%)';
    }
  };

  return (
    <div className="fixed inset-0 pointer-events-none z-50 overflow-hidden">
      {sparkles.map((sparkle) => (
        <div
          key={sparkle.id}
          className="absolute animate-star-twinkle"
          style={{
            top: `${sparkle.top}%`,
            left: `${sparkle.left}%`,
            width: `${sparkle.size}px`,
            height: `${sparkle.size}px`,
          }}
        >
          <img
            src="https://static.readdy.ai/image/b26ccc3ae7fa45b3398224fbc482abd6/074d3102ffad2a455591f49f105c88ed.png"
            alt=""
            className="w-full h-full object-contain"
            style={{
              filter: getColorFilter(sparkle.color),
              dropShadow: `0 0 10px ${sparkle.color}`,
            }}
          />
        </div>
      ))}
    </div>
  );
}
